import { Order, OrderLineType } from "@/app/types/order";
import { Factory } from "fishery";
import { branchFactory } from "./branch";

export const orderItemFactory = Factory.define<OrderLineType>(({ params }) => ({
  productId: 1,
  quantity: 3,
  total: 3900,
  ...params,
}));

export const orderFactory = Factory.define<Order>(({ sequence }) => ({
  branch: branchFactory.build(),
  createdAt: 1581006204,
  id: sequence,
  backupPin: "148",
  deliveryMethod: "home_delivery",
  albaikIdentifier: 123,
  items: [orderItemFactory.build()],
  restaurantId: 3,
  status: "Accepted",
  itemsSubtotal: 3705,
  itemsTax: 195,
  itemsTotal: 3900,
  feesTotal: 0,
  taxPercent: 5,
  ticketNumber: 3,
  total: 3900,
  url: `https://orderonline.albaik.com/order/retrieveOrder/${sequence}`,
  pickupCode: "PICKUP123",
  delivery: {
    status: "pending",
  },
  tax: 195,
  subtotal: 3705,
}));
